module.exports = __webpack_public_path__ + "static/cercazone_sudovest5-69926b7cbe60ee45d906fc9a8cfb920e.jpg";